import React from 'react';
import { Button, Space } from 'antd';
import { FormattedMessage } from 'react-intl';
import { ApiInfo } from 'CommonAPI';
import { useQueryClient } from '@tanstack/react-query';
import { useCollectNow } from 'Settings/hooks/business/subscription';

interface Props {
  isAdminUser: boolean;
}

const OverdueInvoicesBanner: React.FC<Props> = ({ isAdminUser }) => {
  const queryClient = useQueryClient();
  const collectNowMutation = useCollectNow();
  const accountData = (queryClient.getQueryData(['common', 'api']) as ApiInfo)
    ?.account;
  const orgToken: any = queryClient.getQueryState(['subscription', 'token']);

  const handleViewAndPay = () => {
    const merchantId = accountData?.external_id;
    const token = orgToken?.data?.org_token;

    if (!merchantId || !token) {
      return;
    }

    // collectNowMutation generates chargebee hosted payment page
    // via BnM backend subscription-service and returns it's url in response.
    collectNowMutation.mutate(
      {
        org_token: token,
        merchant_id: merchantId,
      },
      {
        onSuccess: (response) => {
          // Open Chargebee hosted page for payment
          // After payment, user will be redirected back by chargebee
          // to route /billing/overdue-payment-return, which
          // is configured in chargebee settings.

          window.location.href = response.url;

          // Force a refetch of due_invoices_count to hide OverdueInvoicesBanner
          queryClient.invalidateQueries({
            queryKey: ['subscription', 'latest'],
          });
        },
      }
    );
  };

  return (
    <Space size="middle">
      <span
        css={`
          white-space: nowrap;
          background-color: #fff2f0;
        `}
      >
        <FormattedMessage defaultMessage="You have outstanding invoices - Please settle them promptly to avoid an interruption of your access." />
      </span>
      {isAdminUser && (
        <Button
          type="default"
          css={`
            color: #ffffff;
            border-color: #ff2e52;
            background-color: #ff2e52;
            &:hover,
            &:focus {
              background-color: #ff2e52 !important;
              color: #ffffff !important;
              text-decoration: underline;
            }
          `}
          onClick={handleViewAndPay}
          loading={collectNowMutation.isPending}
        >
          <FormattedMessage defaultMessage="View & Pay" />
        </Button>
      )}
    </Space>
  );
};

export default OverdueInvoicesBanner;
